import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { clickHomeButton } from '../actions'
import Icon from 'e-submission/components/Icon'

export const AuthenticationInformation = () => {
  const userInfoFromLocalStorage = localStorage.getItem('userInfo')
  const agentInfo = userInfoFromLocalStorage ? JSON.parse(userInfoFromLocalStorage) : {}

  return (
    <div id="main-container">
      <div id="profile">
        <div className="media">
          <a className="media-left"></a>
        </div>
        <ul className="list-group">
          <li className="list-group-item">
            <label>
              <Icon.user />
              <span className={'user-info-label'}>Full name</span>
            </label>
            <div id="fullname">{agentInfo.name}</div>
          </li>
          <li className="list-group-item">
            <label>
              <Icon.email />
              <span className={'user-info-label'}>Email</span>
            </label>
            <div id="email">{agentInfo.email}</div>
          </li>
          <li id="providers" className="list-group-item">
            <div className="row w-100">
              <div className="col">
                <label>
                  <Icon.connect /> <span className={'user-info-label'}>เชื่อมต่อบัญชี</span>
                </label>
              </div>
            </div>
            <div className="w-100 row">
              <div className="name col">IAMC</div>
              <div className="connected col">
                <span>เชื่อมต่อแล้ว</span>
                <Icon.wifiConnected />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  handleHomeButtonClick: bindActionCreators(clickHomeButton, dispatch),
})
const enhance = connect(null, mapDispatchToProps)
export default enhance(AuthenticationInformation)
